import moment from "moment";

export async function overviewData(filters) {
    filters = await parseDatesToISO(filters);
    return axios.get(route('api.manage.companies.analytics.overview'), {
        params: {...filters}
    }).then(response => response.data);
}

// Insights Vacancies
export async function applicationInflux(params) {
    return axios.get(route('api.manage.companies.analytics.insights-vacancies.applications-influx'), {
        params: parseDatesToISO(params)
    }).then(response => response.data);
}

export async function jobReasons(filters, rejected) {
    filters = await parseDatesToISO(filters);
    return axios.get(route('api.manage.companies.analytics.insights-vacancies.job-reasons'), {
        params: {...filters, rejected}
    }).then(response => response.data);
}
export async function jobOutstanding(filters) {
    filters = await parseDatesToISO(filters);
    return axios.get(route('api.manage.companies.analytics.insights-vacancies.job-outstanding'), {
        params: {...filters}
    }).then(response => response.data);
}
export async function intake(filters, type) {
    filters = await parseDatesToISO(filters);
    return axios.get(route('api.manage.companies.analytics.insights-vacancies.intake'), {
        params: {...filters, type},
    }).then(response => response.data);
}
export async function recruitingBudget(filters, tab) {
    filters = await parseDatesToISO(filters);
    return axios.get(route('api.manage.companies.analytics.insights-vacancies.recruiting-budget'), {
        params: {...filters, tab}
    }).then(response => response.data);
}
export async function hireTime(filters) {
    filters = await parseDatesToISO(filters);
    return axios.get(route('api.manage.companies.analytics.insights-vacancies.hire-time'), {
        params: {...filters}
    }).then(response => response.data);
}
export async function statusApplicants(filters) {
    filters = await parseDatesToISO(filters);
    return axios.get(route('api.manage.companies.analytics.insights-vacancies.applicant-status'), {
        params: {...filters}
    }).then(response => response.data)
}
export async function vacancyDates(filters) {
    return axios.get(route('api.manage.companies.analytics.insights-vacancies.vacancy-dates'), {
        params: {...filters},
    }).then(response => response.data)
}
// Insights Vacancy Trends
export async function createdVacancies(params) {
    return axios.get(route('api.manage.companies.analytics.insights-vacancy-trends.created-vacancies'), {
        params: parseDatesToISO(params)
    }).then(response => response.data);
}
export async function activeVacancies(params) {
    return axios.get(route('api.manage.companies.analytics.insights-vacancy-trends.active-vacancies'), {
        params: parseDatesToISO(params)
    }).then(response => response.data);
}
export async function hiredCandidates(params) {
    return axios.get(route('api.manage.companies.analytics.insights-vacancy-trends.hired-candidates'), {
        params: parseDatesToISO(params)
    }).then(response => response.data);

}
// Insights Recruitment Process
export async function recruitProcess(filters){
    filters = await parseDatesToISO(filters);
    return axios.get(route('api.manage.companies.analytics.insights-recruitment-process.recruit-process'), {
        params: {...filters}
    }).then(response => response.data)
}
export async function interviewsStatus(filters){
    filters = await parseDatesToISO(filters);
    return axios.get(route('api.manage.companies.analytics.insights-recruitment-process.interviews-status'), {
        params: {...filters}
    }).then(response => response.data)
}
export async function interviewedCandidates(filters){
    filters = await parseDatesToISO(filters);
    return axios.get(route('api.manage.companies.analytics.insights-recruitment-process.interviewed-candidates'), {
        params: {...filters}
    }).then(response => response.data)
}
export async function interviewsInterviewer(filters){
    filters = await parseDatesToISO(filters);
    return axios.get(route('api.manage.companies.analytics.insights-recruitment-process.interviews-interviewer'), {
        params: {...filters}
    }).then(response => response.data)
}
export async function jobList(filters){
    filters = await parseDatesToISO(filters);
    return axios.get(route('api.manage.companies.analytics.insights-recruitment-process.job-list'), {
        params: {...filters}
    }).then(response => response.data);
}
export async function stages(filters, selectedJobId){
    filters = await parseDatesToISO(filters);
    return axios.get(route('api.manage.companies.analytics.insights-recruitment-process.stages'), {
        params: {...filters, selectedJobId}
    }).then(response => response.data)
}
export async function applicationRejectReasons(filters){
    filters = await parseDatesToISO(filters);
    return axios.get(route('api.manage.companies.analytics.insights-recruitment-process.application-reject-reasons'), {
        params: {...filters}
    }).then(response => response.data)
}
// Insights Sources
export async function applicationSources(filters) {
    filters = await parseDatesToISO(filters);
    return axios.get(route('api.manage.companies.analytics.insights-sources.application-sources'), {
        params: {...filters}
    }).then(response => response.data);
}
export async function interimApplications(filters) {
    filters = await parseDatesToISO(filters);
    return axios.get(route('api.manage.companies.analytics.insights-sources.interim-applications'), {
        params: {...filters}
    }).then(response => response.data);
}
// export
export async function exportCSV(data) {
    return axios.post(route('api.manage.companies.analytics.export.csv'), data)
        .then(({data}) => data)
}

export function fields()
{
    return axios.get(route('api.manage.companies.analytics.export.fields'))
        .then(({data}) => data)
}

function parseDatesToISO(filters) {
    // parse all moment dates to ISO string
    Object.keys(filters).forEach(key => {
        if (moment.isMoment(filters[key])) {
            filters[key] = filters[key].toISOString();
        }
    });

    return filters;
}
